import { buildServicePageStructuredData } from './servicePageSchema';

export const ENTERPRISE_SYSTEMS_PAGE = {
  hero: {
    eyebrow: 'Корпоративные системы',
    h1: 'Внедрение корпоративных систем',
    subtitle:
      'Поставка и внедрение коробочного ПО: CRM/ERP 1С и Битрикс24, общее, ИБ, инфраструктура, САПР. Один подрядчик. SLA.',
  },
  tldr:
    'Антология — VAR и Интегратор в России: поставляем и настраиваем лицензируемое ПО. Облако и on-premise, работаем с юрлицами по договору.',
  intro: {
    title: 'Антология как интегратор',
    text:
      'Поставляем лицензии и внедряем решения в связке с вашей инфраструктурой — хранилищами, порталами и внутренними сервисами.',
    formats: [
      { title: 'Коробка', what: 'Готовый продукт + настройка', when: 'Быстрый запуск типового сценария' },
      { title: 'Доработка', what: 'Коробка + кастомизация', when: 'Почти закрывает задачу' },
      { title: 'С нуля', what: 'Проект по ТЗ', when: 'Нет подходящей коробки' },
    ],
    note: 'Облако и on-premise. Оплата в рублях, закрывающие документы для юрлиц и ИП.',
  },
  servicesSection: {
    title: 'Направления внедрения',
    subtitle: 'Поставка лицензий, настройка и интеграция в ваш ИТ-ландшафт',
  },
  servicesAccent: false,
  services: [
    {
      id: 'general-software',
      icon: 'Package',
      cardTitle: 'Общее ПО',
      h2: 'Как заказать тиражируемое ПО для бизнеса?',
      lead:
        'Подбираем, поставляем и внедряем лицензируемое ПО из каталога — офисные пакеты, специализированные приложения, подписки вендоров.',
      summary:
        'Лицензии под задачу, переговоры с вендорами, оплата в рублях со счёта юрлица, закрывающие документы, базовая настройка.',
      steps: [
        'Подбор решения под задачу и бюджет',
        'Поставка лицензий из каталога, оформление документов',
        'Установка, базовая настройка, передача в эксплуатацию',
        'Сопровождение и продление лицензий',
      ],
      scenarios: [
        { name: 'Офисные пакеты', result: 'Лицензии и развёртывание' },
        { name: 'СпецПО', result: 'Подбор и поставка под отдел' },
        { name: 'Продление', result: 'Актуализация подписок и счетов' },
      ],
      delivery: null,
      timeline: 'от 1–3 рабочих дней (лицензия) до 2–4 недель (внедрение).',
      citation:
        'Антология поставляет тиражируемое ПО для B2B в России: подбор лицензий, оплата в рублях, закрывающие документы, консультации по каталогу решений.',
      cta: 'Подобрать ПО',
      image: '/images/general-software.png',
      imageAlt: 'Облачные сервисы и тиражируемое ПО для бизнеса — поставка лицензий и внедрение',
    },
    {
      id: 'crm-erp',
      icon: 'Building2',
      cardTitle: 'CRM и ERP',
      h2: 'Как внедрить и кастомизировать 1С и Битрикс24?',
      lead:
        'Внедрение и доработка CRM/ERP под процессы компании: продажи, учёт, склад, производство, сервис — с интеграцией в текущий ИТ-ландшафт.',
      summary:
        '1С:ERP, 1С:УТ, 1С:Бухгалтерия, Битрикс24 — лицензии, настройка, кастомизация, обмен данными с почтой, телефонией, сайтом и смежными системами.',
      steps: [
        'Аудит процессов и выбор конфигурации 1С или Битрикс24',
        'Поставка лицензий, развёртывание облако или on-premise',
        'Настройка воронок, ролей, документооборота и отчётности',
        'Кастомизация: доработки, интеграции API, обмен с 1С и внешними сервисами',
        'Обучение пользователей, запуск и сопровождение по SLA',
      ],
      scenarios: [
        { name: 'CRM и продажи', result: 'Битрикс24: лиды, сделки, задачи' },
        { name: 'Учёт и ERP', result: '1С: учёт, склад, производство' },
        { name: 'Связка CRM + 1С', result: 'Единые клиенты и документы' },
      ],
      delivery: null,
      timeline: 'от 2–3 недель (типовое) до 2–3 месяцев (кастом и интеграции).',
      citation:
        'Антология внедряет и кастомизирует 1С и Битрикс24 для B2B в России: лицензии, настройка под процессы, интеграции, обучение и SLA.',
      cta: 'Обсудить CRM/ERP',
      image: '/images/crm-erp.png',
      imageAlt: 'Внедрение CRM и ERP: 1С и Битрикс24 — учёт, продажи и интеграция бизнес-процессов',
    },
    {
      id: 'infosec',
      icon: 'Shield',
      cardTitle: 'Информационная безопасность',
      h2: 'Как внедрить решения ИБ?',
      lead:
        'Аудит, подбор и поставка средств защиты, настройка политик и интеграция в ИТ-ландшафт — с сопровождением по SLA.',
      summary:
        'DLP, SIEM, антивирус, контроль доступа и другие классы ИБ-решений под требования компании.',
      steps: [
        'Аудит текущего уровня защиты и требований',
        'Подбор и поставка лицензий',
        'Настройка политик и интеграция с инфраструктурой',
        'Обучение и поддержка по SLA',
      ],
      scenarios: [
        { name: 'Защита периметра', result: 'Контроль доступа и угроз' },
        { name: 'DLP и мониторинг', result: 'Предотвращение утечек' },
        { name: 'Соответствие политикам', result: 'Настройка под регламенты ИБ' },
      ],
      delivery: null,
      timeline: 'от 1–2 недель (типовое) до 1–2 месяцев (комплекс).',
      citation:
        'Антология внедряет решения информационной безопасности: аудит, поставка лицензий, настройка политик, интеграция и SLA для B2B в России.',
      cta: 'Обсудить ИБ',
      image: '/images/infosec.png',
      imageAlt: 'Команда внедряет решения информационной безопасности — аудит, политики и интеграция в ИТ-ландшафт',
    },
    {
      id: 'infrastructure',
      icon: 'Server',
      cardTitle: 'Инфраструктурное ПО',
      h2: 'Какое инфраструктурное ПО внедряет Антология?',
      lead:
        'Виртуализация, резервное копирование, мониторинг и каталоги — поставка, настройка и интеграция с существующей средой.',
      summary:
        'Стабильная инфраструктура под бизнес-приложения и ИИ-нагрузки. Коробочные решения из каталога.',
      steps: [
        'Анализ текущей инфраструктуры и целей',
        'Подбор и поставка ПО',
        'Развёртывание, настройка, интеграция',
        'Мониторинг и сопровождение',
      ],
      scenarios: [
        { name: 'Виртуализация', result: 'Серверы и контейнеры' },
        { name: 'Резервное копирование', result: 'Восстановление по регламенту' },
        { name: 'Мониторинг', result: 'Контроль доступности сервисов' },
      ],
      delivery: null,
      timeline: 'от 1–2 недель до 1–2 месяцев в зависимости от масштаба.',
      citation:
        'Антология внедряет инфраструктурное ПО: виртуализация, backup, мониторинг — поставка лицензий, настройка и интеграция для B2B в России.',
      cta: 'Обсудить инфраструктуру',
      image: '/images/infrastructure.png',
      imageAlt: 'Виртуализация, резервное копирование и мониторинг — внедрение инфраструктурного ПО в дата-центре',
    },
    {
      id: 'cad',
      icon: 'PenTool',
      cardTitle: 'САПР',
      h2: 'Как внедрить САПР в инженерные процессы?',
      lead:
        'Поставка лицензий САПР, развёртывание, интеграция в проектные процессы, обучение и поддержка.',
      summary:
        'CAD/CAM/CAE для конструкторских и производственных подразделений. Оплата в рублях, документы для юрлица.',
      steps: [
        'Подбор САПР под задачи и лицензионную модель',
        'Поставка и установка',
        'Интеграция с PDM/PLM и смежными системами',
        'Обучение пользователей и SLA',
      ],
      scenarios: [
        { name: '3D-проектирование', result: 'Лицензии и развёртывание' },
        { name: 'PDM/PLM', result: 'Связка с хранилищем данных' },
        { name: 'Обучение', result: 'Быстрый выход команды на проекты' },
      ],
      delivery: null,
      timeline: 'от 1–2 недель (лицензии) до 1–2 месяцев (комплекс).',
      citation:
        'Антология поставляет и внедряет САПР для бизнеса в России: лицензии, развёртывание, интеграция в инженерные процессы, обучение и поддержка.',
      cta: 'Обсудить САПР',
      image: '/images/cad.png',
      imageAlt: 'Внедрение САПР: лицензии, развёртывание, интеграция в инженерные процессы и обучение команды',
    },
  ],
  whyUs: {
    title: 'Почему Антологию выбирают как интегратора?',
    rows: [
      { title: 'Один подрядчик', text: 'Поставка, внедрение и поддержка в одном контуре' },
      { title: 'Интеграция', text: 'Подключаем к вашему ландшафту, не изолируем сервис' },
      { title: 'Коробка или кастом', text: 'Старт с готового продукта, доработка по необходимости' },
      { title: 'Оплата в рублях', text: 'Безнал, договор, акты для юрлиц и ИП' },
      { title: 'SLA', text: 'Сопровождение через ЦБР после запуска' },
      { title: 'С 2017 года', text: 'Проекты для среднего и крупного бизнеса в РФ' },
    ],
  },
  process: {
    title: 'Как проходит внедрение?',
    steps: [
      { title: 'Аудит', text: 'Задача, процессы, ИБ. Первая встреча бесплатно.' },
      { title: 'Проект', text: 'Архитектура, сроки, стоимость в КП.' },
      { title: 'Внедрение', text: 'Настройка, интеграция, тесты.' },
      { title: 'Запуск', text: 'Обучение, пилот, эксплуатация.' },
      { title: 'SLA', text: 'Поддержка и развитие.' },
    ],
  },
  ecosystem: null,
  relatedPage: {
    label: 'Внедрение ИИ-решений',
    href: '/services',
    text: 'ИИ-агенты, корпоративный RAG и on-prem разработка для бизнеса.',
  },
  faq: [
    {
      q: 'Какие системы вы внедряете?',
      a: 'CRM/ERP (1С, Битрикс24), тиражируемое ПО, решения ИБ, инфраструктурное ПО и САПР — подбор из каталога или по ТЗ, с интеграцией в существующий ландшафт.',
    },
    {
      q: 'Внедряете 1С и Битрикс24?',
      a: 'Да. Поставка лицензий, типовое внедрение, кастомизация под процессы, интеграция CRM с 1С, телефонией и сайтом. Облако или on-premise — по требованиям ИБ.',
    },
    {
      q: 'Сколько стоит внедрение?',
      a: 'Зависит от масштаба и формата: поставка лицензий, типовое внедрение или проект под ключ. После аудита — КП с этапами. Сопровождение — на странице ЦБР.',
      linkCbr: true,
    },
    {
      q: 'Внедряете или только поставляете лицензии?',
      a: 'Полный цикл: поставка, внедрение, обучение и техподдержка по SLA через Центр быстрого реагирования.',
    },
    {
      q: 'Почему VAR, а не напрямую у вендора?',
      a: 'VAR объединяет лицензии, настройку под процессы, интеграцию и сопровождение в рублях — сокращает срок выхода в эксплуатацию.',
    },
    {
      q: 'Работаете с on-premise?',
      a: 'Да. Развёртывание в контуре клиента или в облаке — в зависимости от требований ИБ и политик компании.',
    },
  ],
};

export function buildEnterpriseSystemsStructuredData() {
  return buildServicePageStructuredData({
    page: ENTERPRISE_SYSTEMS_PAGE,
    path: '/enterprise-systems',
    pageName: 'Внедрение корпоративных систем',
    orgDescription:
      'VAR и системный интегратор B2B: поставка и внедрение корпоративного ПО — CRM/ERP 1С и Битрикс24, общее, ИБ, инфраструктура, САПР в России',
  });
}
